import { TableCell, TableHead, TableRow } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

export function ReservationDateTimeListHeader(props: any) {
  const dateFrom = new Date(props.from.slice(0, 4) + '/' + props.from.slice(4, 6) + '/' + props.from.slice(6, 8));
  const dateTo = new Date(props.to.slice(0, 4) + '/' + props.to.slice(4, 6) + '/' + props.to.slice(6, 8));

  function formatDate(date: Date) {
    return (date.getMonth() + 1).toString() + '/' + date.getDate().toString();
  }

  function getDayOfWeek(date: Date) {
    const week = ['日', '月', '火', '水', '木', '金', '土'];
    return week[date.getDay()];
  }

  const dateCells = [];
  const dayCells = [];
  let isFirst = true;

  for (let date = dateFrom; date <= dateTo; date = new Date(date.getTime() + 1000 * 60 * 60 * 24)) {
    const isSunday = date.getDay() === 0;
    const leftBorderStyle = isFirst ? '1px solid #ddd' : 'none';

    dateCells.push(
      <TableCell
        key={uuidv4()}
        align="center"
        sx={{
          borderLeft: leftBorderStyle, // 最初のセルに左側の縦線を追加
          borderRight: '1px solid #ddd', // 縦線を追加
          borderBottom: '1px solid #ddd' // 横線を追加
        }}
        className="font-bold" // 日付に太字を適用
      >
        {formatDate(date)}
      </TableCell>
    );
    dayCells.push(
      <TableCell
        key={uuidv4()}
        align="center"
        sx={{
          color: isSunday ? 'red' : 'inherit',
          borderLeft: leftBorderStyle, // 最初のセルに左側の縦線を追加
          borderRight: '1px solid #ddd', // 縦線を追加
          borderBottom: '1px solid #ddd' // 横線を追加
        }}
        className="font-bold" // 曜日に太字を適用
      >
        {getDayOfWeek(date)}
      </TableCell>
    );

    isFirst = false; // 最初のセル処理が完了したため、フラグを下げる
  }

  return (
    <TableHead>
      <TableRow
        sx={{
          '& .MuiTableCell-root': {
            height: '10px',
            padding: '0',
            borderTop: '1px solid #ddd' // 上線を追加
          }
        }}
      >
        <TableCell key={uuidv4()}></TableCell>
        {dateCells}
      </TableRow>
      <TableRow
        sx={{
          '& .MuiTableCell-root': {
            height: '10px',
            padding: '0'
          }
        }}
      >
        <TableCell key={uuidv4()}></TableCell>
        {dayCells}
      </TableRow>
    </TableHead>
  );
}
